import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    ratingRootColor: {
      color: theme.palette.secondary.main,
    },
  })
)
